import { EditListingForm } from "../components/EditListing.js/EditListingForm";
import { Navbar } from "../components/Navbar";

const EditLisitng = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <main className="flex-1 pt-24 pb-16">
        <div className="container px-4 mx-auto">
          <div className="max-w-2xl mx-auto">
            {/* Header */}
            <div className="mb-8">
              <h1 className="text-3xl font-bold mb-2">Edit Listing</h1>
              <p className="text-muted-foreground">Keep your listings up to date so others can have full detail</p>
            </div>

            {/* Lisitng Form */}
            <div className="bg-white p-6 rounded-xl border border-border/60 shadow-sm">
              <EditListingForm />
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-igbanwo-mint/5 p-8 border-t border-border/60">
        <div className="container px-4 mx-auto text-center text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} Thoreau Consulting (PTY) Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default EditLisitng;
